import React from 'react';

export const UpdateThumbnailIcon = ({ ...rest }) => {
  return (
    <svg
      width="101"
      height="91"
      viewBox="0 0 101 91"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <ellipse cx="50.5" cy="71" rx="50" ry="19.5" fill="#2178F6" fillOpacity="0.15" />
      <rect x="15" y="1" width="70" height="75" fill="white" stroke="#315E97" />
      <rect
        x="20"
        y="5"
        width="60.875"
        height="44"
        fill="#2178F6"
        fillOpacity="0.15"
        stroke="#315E97"
      />
      <rect x="29.0625" y="11.25" width="11.25" height="11.25" rx="5.625" fill="#315E97" />
      <path
        d="M62.9969 35.3655L63.2562 35.4167L63.4446 35.2313L80.875 18.069V49H27.3073L41.9154 31.2047L62.9969 35.3655Z"
        fill="white"
        stroke="#315E97"
      />
      <path
        d="M70.5 70.5C70.5 62.2157 77.2157 55.5 85.5 55.5C93.7843 55.5 100.5 62.2157 100.5 70.5C100.5 78.7843 93.7843 85.5 85.5 85.5C77.2157 85.5 70.5 78.7843 70.5 70.5Z"
        fill="#2178F6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M85.5 63.8333C85.9602 63.8333 86.3333 64.2064 86.3333 64.6666V76.3333C86.3333 76.7935 85.9602 77.1666 85.5 77.1666C85.0398 77.1666 84.6667 76.7935 84.6667 76.3333V64.6666C84.6667 64.2064 85.0398 63.8333 85.5 63.8333Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M78.8333 70.5C78.8333 70.0398 79.2064 69.6667 79.6667 69.6667H91.3333C91.7936 69.6667 92.1667 70.0398 92.1667 70.5C92.1667 70.9603 91.7936 71.3334 91.3333 71.3334H79.6667C79.2064 71.3334 78.8333 70.9603 78.8333 70.5Z"
        fill="white"
      />
    </svg>
  );
};

export default UpdateThumbnailIcon;



// WEBPACK FOOTER //
// ./src/vp-ui/svgs/UpdateThumbnailIcon.jsx